import { render, staticRenderFns } from "./ChatOutlinedIcon.vue?vue&type=template&id=e369bd4a&"
import script from "./ChatOutlinedIcon.vue?vue&type=script&lang=js&"
export * from "./ChatOutlinedIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports